import { PrivateAccessType } from '../../../../../interfaces/interfaces';

export const DOCUMENTATION_URLS = {
  USER_ID_AGENT: 'https://docs.paloaltonetworks.com/ngfw/help/11-2/device/device-data-redistribution/device-data-redistribution-agents',
  RESOURCE_GATEWAY: 'https://docs.aws.amazon.com/vpc/latest/privatelink/create-resource-gateway.html',
  LDAP: 'https://docs.paloaltonetworks.com/ngfw/help/11-2/device/device-server-profiles-ldap',
  AWS_RESOURCE_GATEWAY_OVERVIEW: 'https://docs.aws.amazon.com/vpc/latest/privatelink/resource-gateway.html',
} as const;

export const PRIVATE_ACCESS_CONFIG = {
  Firewall: ['FirewallId', 'Region', 'PvtAccess', 'UpdateToken', 'DeploymentUpdateToken'],
  Status: ['PvtAccessStatus'],
} as const;

export const getResourceTypeOptions = (translate: (key: string) => string): Array<{ children: string; value: PrivateAccessType }> => [
  {
    children: translate('resources.firewallsV2.privateAccess.userIdRedistributionAgent'),
    value: 'USERID',
  },
  {
    children: translate('resources.firewallsV2.privateAccess.lDAPProfile'),
    value: 'LDAP',
  },
];
